import { h } from '@stencil/core';
import { calculateRuntime, formatMessage, stringifyRuntime, validate } from '../utils';
import { RUNTIME_ERROR_CODES_TO_LABELS } from '../constants';
export class RuntimeLoadCell {
  constructor() {
    this.value = '';
    this.labels = undefined;
    this.runtimeParams = undefined;
    this.default = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getErrorMessage(errorCode) {
    var _a;
    const labelCode = RUNTIME_ERROR_CODES_TO_LABELS.LOAD[errorCode];
    const message = (_a = this.labels) === null || _a === void 0 ? void 0 : _a[labelCode];
    return formatMessage(message, labelCode, this.runtimeParams);
  }
  render() {
    if (this.default) {
      return h("div", null);
    }
    const errorMessage = this.getErrorMessage(validate(this.runtimeParams, this.value));
    const value = errorMessage ? null : calculateRuntime(this.runtimeParams, this.value);
    return (h("pes-runtime-base-cell", null, h("div", { slot: "value" }, stringifyRuntime(value, this.labels)), errorMessage && h("div", { slot: "error" }, errorMessage)));
  }
  static get is() { return "pes-runtime-load-cell"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-runtime-load-cell.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-runtime-load-cell.css"]
    };
  }
  static get properties() {
    return {
      "value": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "runtime value"
        },
        "attribute": "value",
        "reflect": false,
        "defaultValue": "''"
      },
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRuntimeTranslations",
          "resolved": "{ enterTotalLoad: string; enteredLoadLessMinimum: string; hours: string; indicatesCapacity: string; maxCapacityUsed: string; minMax: string; minutes: string; pleaseEnterLoad: string; pleaseEnterLoadMaxCapacity: string; runTime: string; seconds: string; totalLoadExceeds: string; watts: string; }",
          "references": {
            "TRuntimeTranslations": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "runtime translations"
        }
      },
      "runtimeParams": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRuntimeAttributes",
          "resolved": "{ id?: string; vah: number; bcurveComp: number; bcurveExpo: number; bcurveSlope: number; bcurveScale: number; ptare: number; startPoint?: number; pwrRated: number; maxPower: number; }",
          "references": {
            "TRuntimeAttributes": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "product runtime parameters"
        }
      },
      "default": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "default props for run-time on comparison"
        },
        "attribute": "default",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get elementRef() { return "el"; }
}
